export default __webpack_public_path__ + "static/media/Confirmed.67609d6f.svg";